export const CANCEL_PIPELINE = "CANCEL_PIPELINE";


export function resetPipelines() {
  return dispatch => {
    dispatch({ type: CANCEL_PIPELINE, payload: false })
  }
}
